import { apiClient, apiProvider } from './utilities/Provider';

const verifyToken = async (token, mode = 'activation') => {
    const path = mode === 'reset'
        ? `/activation/verify-reset/${token}`
        : `/activation/verify/${token}`;
    const response = await apiClient.get(path);
    return response.data;
};

const setPassword = (token, password) =>
    apiProvider.post('activation/set-password', { token, password });

const confirmPasswordReset = (token, password) =>
    apiProvider.post('activation/password-reset/confirm', { token, password });

const requestPasswordReset = (email) =>
    apiProvider.post('activation/password-reset/request', { email }, { headers: { 'X-Portal-Origin': 'CyberJob' } });

const ActivationService = { verifyToken, setPassword, confirmPasswordReset, requestPasswordReset };

export default ActivationService;
